import { Certificate } from './certificate.model';

export class CertificateCommand {
    certificate_name: string;

    constructor(certificate: Certificate, public id?: string) {
        this.certificate_name = certificate.name;
    }
}
